import { createAction, props } from '@ngrx/store';
import { TimeBlockRequestParams } from '../../../../features/calendar/components/time-block/types/time-block-types';
import { undoable } from '../../undo-redo/undo-redo.actions';
import { ITimeBlockComponentItem } from '../../../../features/calendar/components/time-block/types/time-block-component-item-types';
import {
  MultipleTimeBlockDeletedResponse,
  TimeBlockDeletedResponse,
  TimeBlockModifiedResponse,
  TimeBlockUpdatedResponse,
} from '../../../../shared/data-types/http-response-types';
import { UndoRedoMeta } from '../../../../shared/data-types/undo-redo-types';
import { HttpTypes } from '../../../../shared/data-types/http-types';

export const fetchTimeBlockList = createAction(
  '[Time Blocks] Fetch Timeblocks',
  props<{
    payload: TimeBlockRequestParams;
  }>(),
);
// This action should only be called once during loading process, otherwise undo/redo functionality might break.
export const setInitialTimeBlocks = undoable(
  createAction(
    '[Time Blocks] Set TimeBlocks',
    props<{
      payload: readonly ITimeBlockComponentItem[];
      storeInHistory: boolean;
    }>(),
  ),
);

// Fetch time blocks for a specific task
export const fetchTimeBlocksForTasks = createAction(
  '[Task Time Blocks] Fetch Task TimeBlocks',
  props<{
    payload: {
      taskIds: number[];
      isInvoiced: boolean | null;
      includeActiveTimeBlock: boolean;
    };
  }>(),
);
export const setTimeBlocksForTask = createAction(
  '[Task Time Blocks] Set Task TimeBlocks',
  props<{
    payload: readonly ITimeBlockComponentItem[];
  }>(),
);

// Fetch active time block
export const fetchActiveTimerTimeBlock = createAction(
  '[Task Time Blocks] Fetch Active Timer TimeBlocks',
  props<{ payload: number }>(),
);
export const setActiveTimerTimeBlock = createAction(
  '[Task Time Blocks] Set Active Timer TimeBlocks',
  props<{ payload: ITimeBlockComponentItem | null }>(),
);

export const addTimeBlock = createAction(
  '[Time Blocks] Add TimeBlock',
  props<{ payload: ITimeBlockComponentItem }>(),
);
export const timeBlockAdded = createAction(
  '[Time Blocks] TimeBlock Added',
  props<{ payload: TimeBlockModifiedResponse }>(),
);

export const updateTimeBlock = undoable(
  createAction(
    '[Time Blocks] Update TimeBlock',
    props<{
      payload: ITimeBlockComponentItem;
      storeInHistory: boolean;
      undoRedoMeta: UndoRedoMeta;
    }>(),
  ),
);
export const timeBlockUpdated = createAction(
  '[Time Blocks] TimeBlock Updated',
  props<{ payload: TimeBlockUpdatedResponse }>(),
);

export const deleteTimeBlock = createAction(
  '[Time Blocks] Delete TimeBlock',
  props<{ payload: number }>(),
);
export const timeBlockDeleted = createAction(
  '[Time Blocks] TimeBlock Deleted',
  props<{ payload: TimeBlockDeletedResponse }>(),
);

export const deleteMultipleTimeBlocks = createAction(
  '[Time Blocks] Delete Multiple TimeBlock',
  props<{ payload: number[] }>(),
);
export const multipleTimeBlocksDeleted = createAction(
  '[Time Blocks] Multiple TimeBlocks Deleted',
  props<{ payload: MultipleTimeBlockDeletedResponse }>(),
);

export const purgeTimeBlockStore = createAction('[Time Blocks] Purge TimeBlocks');

export const httpFail = createAction('[Time Blocks] Http fail', props<{ payload: HttpTypes }>());
